import RoleEdit from './role.edit';
import RoleCreate from './role.create';
import RoleShow from './role.show';

export default {
  edit: RoleEdit,
  create: RoleCreate,
  show: RoleShow,
};
